export function hexToRgba(hex, alpha = 0.13) {
  // Remove 'var(' and ')' if present
  if (hex?.startsWith("var(")) {
    // Get the computed value from the CSS variable
    hex = getComputedStyle(document.documentElement).getPropertyValue(
      hex.replace(/[()]/g, "").replace("var", "").trim()
    );
  }
  hex = hex?.replace("#", "").trim();
  if (hex?.length === 3) {
    hex = hex
      .split("")
      .map((x) => x + x)
      .join("");
  }
  const num = parseInt(hex, 16);
  const r = (num >> 16) & 255;
  const g = (num >> 8) & 255;
  const b = num & 255;
  return `rgba(${r},${g},${b},${alpha})`;
}
